import { environment } from "../../../../environments/environment";
import axios from "axios";
import qs from "qs";
import { CreateProfessionalAccountRequestData } from "../../../shared-components/paymentDetails/paymentDetails.component";
import { PaymentLinkListQuery, PaymentLinkListResponse, PaymentLinkOrder } from "@med_poc/types";

export const createProfessionalPaymentAccount = async (postData: CreateProfessionalAccountRequestData) => {
  let data = JSON.stringify(postData);

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `${environment.apiUrl}api/payment/create-professional-account`,
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axios
    .request(config)
    .then((response) => {
      console.devlog(JSON.stringify(response.data));
      return response;
    })
    .catch((error) => {
      console.devlog(error);
      throw error;
    });
};

export const checkVerificationStatus = async (principalId?: string) => {
  let config = {
    method: "get",
    maxBodyLength: Infinity,
    url: `${environment.apiUrl}api/payment/account-info`,
    headers: {
      "Content-Type": "application/json",
    },
    ...(principalId ? { params: { principalId } } : {}),
  };
  return axios
    .request(config)
    .then((response) => {
      console.devlog(JSON.stringify(response.data));
      return response;
    })
    .catch((error) => {
      console.devlog(error);
      throw error;
    });
};

export const getMyCards = async () => {
  let config = {
    method: "get",
    maxBodyLength: Infinity,
    url: `${environment.apiUrl}api/payment/get-my-cards`,
    headers: {
      "Content-Type": "application/json",
    },
  };
  return axios
    .request(config)
    .then((response) => {
      console.devlog(JSON.stringify(response.data));
      return response;
    })
    .catch((error) => {
      console.devlog(error);
      throw error;
    });
};

export const registerPaymentCard = async () => {
  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `${environment.apiUrl}api/payment/register-card`,
    headers: {
      "Content-Type": "application/json",
    },
  };

  return axios
    .request(config)
    .then((response) => {
      console.devlog(JSON.stringify(response.data));
      return response;
    })
    .catch((error) => {
      console.devlog(error);
      throw error;
    });
};

export const chargePatient = async () => {
  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `${environment.apiUrl}api/payment/charge-user`,
    headers: {
      "Content-Type": "application/json",
    },
    // TODO: remove hardcoded data
    data: {
      payerId: 228,
      // amount: 9906,
            amount: 88,
      reason: "Book appointment",
    },
  };

  return axios
    .request(config)
    .then((response) => {
      console.devlog(JSON.stringify(response.data));
      return response;
    })
    .catch((error) => {
      console.devlog(error);
      throw error;
    });
};

export const deletePaymentCard = async (cardUniqueReference: string) => {
  console.devlog("Deleting card with reference:", cardUniqueReference);
  let config = {
    method: "delete",
    maxBodyLength: Infinity,
    url: `${environment.apiUrl}api/payment/cards/${cardUniqueReference}`,
    headers: {
      "Content-Type": "application/json",
    },
  };
  return await axios
    .request(config)
    .then((response) => {
      console.devlog(JSON.stringify(response.data));
      return response;
    })
    .catch((error) => {
      console.devlog(error);
      throw error;
    });
};


export const setDefaultPaymentCard = async (cardUniqueReference: string) => {
  let config = {
    method: "put",
    maxBodyLength: Infinity,
    url: `${environment.apiUrl}api/payment/cards/${cardUniqueReference}/default`,
    headers: {
      "Content-Type": "application/json",
    }
  }
  return await axios
    .request(config)
    .then((response) => {
      console.devlog(JSON.stringify(response.data));
      return response;
    })
    .catch((error) => {
      console.devlog(error);
      throw error;
    });
}

export const createPaymentLink = async (data: PaymentLinkOrder, invoice?: File | null)=>{

  const form = new FormData();
  form.append("amount", String(data.amount));
  form.append("customerTrns", data.customerTrns);
  form.append("customerEmail", data.customer.email);
  form.append("customerFullName", data.customer.fullName);
  // if (data.customer.phone) form.append("customerPhone", data.customer.phone);
  // if (data.customer.countryCode) form.append("customerCountryCode", data.customer.countryCode);
  form.append("transferAmount", String(data.transfer.amount));
  if (data.cnsCode) form.append("cnsCode", data.cnsCode);
  if (data.payTo) form.append("payTo", data.payTo);
  if (data.groupId) form.append("groupId", data.groupId);
  if (invoice) form.append("invoice", invoice, invoice.name);

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `${environment.apiUrl}api/payment-link/createPaymentLink`,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data: form,
  };

  return axios
    .request(config)
    .then((response) => {
      console.devlog(JSON.stringify(response.data));
      return response;
    })
    .catch((error) => {
      console.devlog(error);
      throw error;
    });

}

export const getPaymentLinks = async (params: PaymentLinkListQuery): Promise<PaymentLinkListResponse> => {
  const queryString = qs.stringify(params, { encodeValuesOnly: true, skipNulls: true });
  const response = await axios({
    method: 'get',
    url: `${environment.apiUrl}api/payment-link/findChecked?${queryString}`,
    headers: { Accept: 'application/json' },
  });
  return response.data;
}


export const resendPaymentLink = async (documentId: string, email: string) => {
  const response = await axios({
    method: 'post',
    url: `${environment.apiUrl}api/payment-link/resendPaymentLink/${documentId}`,
    headers: { 'Content-Type': 'application/json' },
    data: { email },
  });
  return response.data;
};
